import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum CrmOfferDiscountTypeId {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
  CHANGE_PRICE = 'changePrice',
}

export class CrmOfferDiscountType extends Codebook<CrmOfferDiscountTypeId> {
  static readonly PERCENTAGE = new CrmOfferDiscountType(
    CrmOfferDiscountTypeId.PERCENTAGE,
    () => $t('Percentage'),
    '%',
  )
  static readonly AMOUNT = new CrmOfferDiscountType(
    CrmOfferDiscountTypeId.AMOUNT,
    () => $t('Amount'),
    null,
  )
  static readonly CHANGE_PRICE = new CrmOfferDiscountType(
    CrmOfferDiscountTypeId.CHANGE_PRICE,
    () => $t('Change price'),
    null,
  )

  private constructor(
    id: CrmOfferDiscountTypeId,
    public readonly name: () => string,
    public readonly valueSuffix: string | null,
  ) {
    super(id)
  }
}
